document.addEventListener('DOMContentLoaded', function () {
  const topicSelect = document.getElementById('topic');
  const disclaimers = document.querySelectorAll('.disclaimer');
  const formDetails = document.getElementById('formDetails');
  const topicValue = document.getElementById('topicValue');

  topicSelect.addEventListener('change', function () {
    // Hide disclaimers
    disclaimers.forEach(d => d.style.display = 'none');

    const selected = this.value;
    const valueStrings = {
      "shipping": "Order status and Shipping",
      "returns": "Returns",
      "product": "Product Information",
      "warranty": "Warranty & Claims",
      "payments": "Payment and invoicing",
      "other": "Other"
    }
    topicValue.value = valueStrings[selected];
    
    // Show selected disclaimer if it exists
    const selectedDisclaimer = document.getElementById(selected + 'Disclaimer');
    if (selectedDisclaimer) {
      selectedDisclaimer.style.display = 'block';
    }

    // Show the rest of the form if a topic is selected
    formDetails.style.display = selected ? 'block' : 'none';
  });
});
